import { ChatUserStatusStore, Presence } from './chat-user-status.store';
import { Meeting } from '../models/chat';
import { AuthServiceInterface } from './AuthServiceInterface';
import { ChatMeetingService } from './chat-meeting.service';
import { MeetingUtilService } from './meeting-util.service';

export class ChatUserStatusService {
    static $inject = ['WebSocket', 'ChatUserStatusStore', 'AuthService', 'ChatMeetingService', 'MeetingUtilService'];

    constructor(
        private webSocket: WebSocketService,
        private chatUserStatusStore: ChatUserStatusStore,
        private authService: AuthServiceInterface,
        private chatMeetingService: ChatMeetingService,
        private meetingUtilService: MeetingUtilService
    ) {}

    init() {
        this.webSocket.on('presence:initial', (presences: Presence[]) => {
            presences.forEach((presence) => this.chatUserStatusStore.dispatchPresenceChanged(presence));
        });

        this.webSocket.on('presence:changed', (presence: Presence) => {
            this.chatUserStatusStore.dispatchPresenceChanged(presence);
        });

        this.chatMeetingService.getChatKey().then((chatKey) => {
            this.webSocket.emit('join:presence', [this.authService.getUserId()], chatKey);
        });
    }

    getStatusForMeeting$(meeting: Meeting) {
        // we only support 1 on 1 meetings
        if (meeting.type !== 'private') {
            return Rx.Observable.from([null]);
        }

        const otherUserId = this.meetingUtilService.getPrivateMeetingConversationPartnerId(meeting);

        if (!otherUserId) {
            return Rx.Observable.from(null);
        }

        return this.chatUserStatusStore.getPresence$(otherUserId);
    }
}

angular.module('tradersyard').service('ChatUserStatusService', ChatUserStatusService);
